module.exports = __webpack_public_path__ + "img/portfolio1m.9d3c7e5c.jpg";